// extracted by mini-css-extract-plugin
export default {"countdown":"Countdown_countdown__mWi50","countdownText":"Countdown_countdownText__SP0Ge","countdownNode":"Countdown_countdownNode__EhjP1"};